var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React, { useRef } from 'react';
import { bindActionCreators } from 'redux';
import { actions } from 'react-redux-form';
import { connect } from 'react-redux';
import { get } from 'lodash';
import { Icon } from "../../UI";
import { Translate } from "../../I18N";

import { MetadataFormFiles } from "./MetadataFormFiles";





const handlePDFUpload =
(event, model) => (dispatch) => {
  const { files } = event.target;
  if (files && files.length > 0) {
    Array.from(files).forEach((file) => {
      const data = { data: URL.createObjectURL(file), originalFile: file };
      dispatch(actions.push(`${model}.documents`, data));
    });
  }
};

const mapStateToProps = (state, ownProps) => {
  const entity = get(state, ownProps.model);
  return {
    entity
  };
};

const mapDispatchToProps = (dispatch) =>
bindActionCreators({ handlePDFUploadAction: handlePDFUpload }, dispatch);

const connector = connect(mapStateToProps, mapDispatchToProps);




const PDFUpload = ({ model, entity, handlePDFUploadAction }) => {
  const inputFileRef = useRef(null);

  const handleUploadButtonClicked = () => {var _inputFileRef$current;
    (_inputFileRef$current = inputFileRef.current) === null || _inputFileRef$current === void 0 ? void 0 : _inputFileRef$current.click();
  };

  return /*#__PURE__*/(
    _jsx("div", { className: "document-list-parent" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "attachments-list-header editor" }, void 0, /*#__PURE__*/
    _jsx("h2", {}, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Primary Documents")
    ), /*#__PURE__*/
    _jsx("button", { type: "button", onClick: handleUploadButtonClicked, className: "btn" }, void 0, /*#__PURE__*/
    _jsx(Icon, { icon: "plus" }), "\xA0", /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Add PDF")
    )
    ), /*#__PURE__*/
    React.createElement("input", {
      "aria-label": "pdfInput",
      type: "file",
      onChange: (event) => handlePDFUploadAction(event, model),
      style: { display: 'none' },
      ref: inputFileRef,
      accept: "application/pdf",
      multiple: true }
    ), /*#__PURE__*/
    _jsx(MetadataFormFiles, { model: model, type: "document", files: entity.documents })
    ));

};

const container = connector(PDFUpload);
export { container as PDFUpload };